import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import FAQ from "../components/FAQ";

export default withRouter(connect()(FAQ));
